import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=3b9cb57e&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=3b9cb57e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9cb57e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b9cb57e')) {
      api.createRecord('3b9cb57e', component.options)
    } else {
      api.reload('3b9cb57e', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=3b9cb57e&scoped=true", function () {
      api.rerender('3b9cb57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/goods.vue"
export default component.exports